import reducer from './reducers';

import * as profileActions from './actions';
import * as profileTypes from './types';

export { profileActions, profileTypes };

export default reducer;
